// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDataauditresmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDataauditresmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDataauditresmgrIconOutlined = function DrrpDataauditresmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDataauditresmgrIconOutlinedSvg
  }));
};

DrrpDataauditresmgrIconOutlined.displayName = 'DrrpDataauditresmgrIconOutlined';
export default React.forwardRef(DrrpDataauditresmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDataauditresmgrIconOutlined.js
// module id = 2535
// module chunks = 0